export default __webpack_public_path__ + "static/media/016-home-1.4236b4b3.png";